import { useEffect, useState } from "react";
import { Table } from "reactstrap";
import consorcioService from "services/ConsorcioService";
import ResponsaveisConsorcio from "./ResponsaveisConsorcio";

export default function ({ idConsorcio }) {
  const [empresas, setEmpresas] = useState([])

  useEffect(() => {
    if (idConsorcio) {
      consorcioService.getEmpresas(idConsorcio).then(res => {
        if (res.success) {
          setEmpresas(res.data)
        } else {
          setEmpresas([])
        }
      })
    }
  }, [idConsorcio])

  return (
    <div className="row">
      <div className="col-12">
        <h4>Empresas participantes do consórcio</h4>
        <Table className="align-items-center table-flush" responsive>
          <thead className="thead-light">
            <tr>
              <th scope="col">CNPJ</th>
              <th scope="col">Razão Social</th>
              <th scope="col">Nome Fantasia</th>
              <th scope="col">Email</th>
            </tr>
          </thead>
          <tbody>
            {empresas.map(el => (
              <tr key={el.id}>
                <td>{el.cnpjFmt}</td>
                <td>
                  {el.razaoSocial}
                  {el.lider && (
                    <span className="badge badge-success ml-2">Líder</span>
                  )}

                </td>
                <td>{el.nomeFantasia}</td>
                <td>{el.email}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <ResponsaveisConsorcio idConsorcio={idConsorcio} />
    </div>
  )
}